module.exports = __webpack_public_path__ + "img/mir.89635832.png";